<!-- eslint-disable @angular-eslint/template/prefer-ngsrc -->
<button
  (click)="playClicked.emit()"
  (mouseenter)="buttonHovered.set(true)"
  (mouseleave)="buttonHovered.set(false)"
>
  @if (!buttonHovered()) {
    <img
      class="w-10 md:w-16 m-2"
      src="/assets/icons/big-play-circle-icon.svg"
      alt="play"
    />
  }
  @if (buttonHovered()) {
    <img
      class="w-10 md:w-16 m-2"
      src="/assets/icons/big-play-circle-icon-hover.svg"
      alt="play"
    />
  }
</button>
<p
  class="text-xxs md:text-[14px] font-medium tracking-wider leading-4 mb-2 md:mb-6 uppercase"
>
  {{ playButtonMessage }}
</p>
